var _rect, _path, _rect2, _mask, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBrowsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E7E9EF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.75H20c.82 0 1.5.68 1.5 1.5V18c0 .844-.68 1.5-1.5 1.5h-4.125l.234.75h1.641c.398 0 .75.352.75.75 0 .422-.352.75-.75.75h-6A.74.74 0 0 1 11 21c0-.398.328-.75.75-.75h1.617l.258-.75H9.5A1.48 1.48 0 0 1 8 18v-6.75c0-.82.656-1.5 1.5-1.5zm10.5 1.5H9.5v5.25H20v-5.25z",
    fill: "#233145"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6,
    y: 12.85,
    width: 6.8,
    height: 9.8,
    rx: 1.4,
    stroke: "#fff",
    strokeWidth: 0.8
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "qbbv5b5p4a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13.25,
    width: 6,
    height: 9,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13.25,
    width: 6,
    height: 9,
    rx: 1,
    fill: "#fff",
    stroke: "#233145",
    strokeWidth: 3,
    mask: "url(#qbbv5b5p4a)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBrowsers);
export default __webpack_public_path__ + "static/media/cross_browsers.ad436ed7ad146a3aa191f938cbf2195e.svg";
export { ForwardRef as ReactComponent };